import React, { useState } from "react";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { viewImage } from "../../CommonUtils/viewImage";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import Swal from "sweetalert2";

export default function TrackUrConcern() {
  const [concernId, setConcernId] = useState("");
  const [grievanceDetails, setGrievanceDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const getGrievanceDetails = async () => {
    if (!concernId.trim()) {
      Swal.fire("Please enter Concern ID");

      setGrievanceDetails(null);
      setSearched(false);
      return;
    }

    setLoading(true);
    setSearched(true);
    setGrievanceDetails(null);

    try {
      const res = await axios.get(
        `${config.url.FAC_URL}Getgrivencedetils?grievId=${concernId.trim()}`
      );


      if (
        res?.data?.scode === "01" &&
        Array.isArray(res?.data?.data) &&
        res.data.data.length > 0
      ) {
        setGrievanceDetails(res.data.data);
      } else {
        setGrievanceDetails(null);
      }
    } catch (error) {
      console.error("Error fetching Concern details:", error);
      setGrievanceDetails(null);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      getGrievanceDetails();
    }
  };

  const grievance = grievanceDetails?.[0];

  return (
    <div className="container mt-4">
      <div className="card shadow border-0">
        <div className="card-body">
          <h4 className="card-title mb-4 text-primary">
            Track Your Concern
          </h4>

          <div className="row align-items-end">
            <div className="col-md-4 mb-3">
              <label htmlFor="concernId" className="form-label fw-bold">
                Enter Concern ID
              </label>
              <input
                id="concernId"
                type="text"
                className="form-control"
                value={concernId}
                // onChange={(e) => setConcernId(e.target.value)}
                onChange={(e) => {
                  setConcernId(e.target.value);
                  setGrievanceDetails(null);
                  setSearched(false);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Enter your concern ID"
              />
            </div>

            <div className="col-md-4 mb-3">
              <button
                type="button"
                className="btn btn-primary "
                onClick={getGrievanceDetails}
                disabled={loading}
              >
                {loading ? "Searching..." : "Track Concern"}
              </button>
            </div>
          </div>

          {loading && (
            <div className="text-center mt-4">
              <div
                className="spinner-border text-primary"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Fetching grievance details...</p>
            </div>
          )}

          {!loading && grievance && (
            <div className="table-responsive mt-4">
              <table className="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th width="30%">Concern ID</th>
                    <td>{grievance.griev_id || "-"}</td>
                  </tr>
                  <tr>
                    <th>College Code</th>
                    <td>{grievance.coll_code || "-"}</td>
                  </tr>
                  <tr>
                    <th>Mobile Number</th>
                    <td>{grievance.mobileno || "-"}</td>
                  </tr>
                  <tr>
                    <th>NOC Type</th>
                    <td>{grievance.noc_type || "-"}</td>
                  </tr>
                  <tr>
                    <th>Problem Type</th>
                    <td>  {grievance.pblm_type
                      ? (grievance.pblm_type === "A" ? "Administrative" : "Technical")
                      : "-"}</td>
                  </tr>
                  <tr>
                    <th>Concern</th>
                    <td>{grievance.grievance || "-"}</td>
                  </tr>
                  <tr>
                    <th>Remarks</th>
                    <td>{grievance.status_remarks || "-"}</td>
                  </tr>
                  <tr>
                    <th>Supporting Document</th>
                    <td>
                      {grievance.support_doc ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() =>
                            viewImage(grievance.support_doc)
                          }
                        >
                          {/* View Attachment */}
                          <FaEye size={18} className="mt-0" />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>
                      <span
                        className={`badge ${grievance.status
                          ? "bg-success"
                          : "bg-warning text-dark"
                          }`}
                      >
                        {grievance.status ? "Closed" : "Pending"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Submitted On</th>
                    <td>
                      {grievance.insert_time
                        ? new Date(
                          grievance.insert_time.slice(0, 23)
                        ).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Attachment</th>
                    <td>
                      {grievance.grievupload ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() =>
                            viewImage(grievance.grievupload)
                          }
                        >
                          {/* View Attachment */}
                          <FaEye size={18} className="mt-0" />
                        </button>
                      ) : (
                        "No Attachment"
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {!loading && searched && !grievance && (
            <div className="alert alert-warning mt-4">
              No concern found for ID:{" "}
              <strong>{concernId}</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}